"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const offeringsData = [{
  title: "Anfrage & Planung",
  description: "Teilen Sie uns Ihre Event-Details mit. Wir planen gemeinsam die optimale Bechermenge und Logistik.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/image_asxqri4t.png",
  link: "/ContactPage",
  colSpan: "md:col-span-1 lg:col-span-7"
}, {
  title: "Lieferung",
  description: "Pünktliche Zustellung Ihrer Mehrwegbecher direkt zum Veranstaltungsort in ganz Kärnten.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/image_xb40etq4.png",
  link: "/ServicesPage",
  colSpan: "md:col-span-1 lg:col-span-5"
}, {
  title: "Das Event",
  description: "Nachhaltig feiern ohne Müllberge. Ihre Gäste genießen Getränke aus hochwertigen Mehrwegbechern.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/image_u4d4jhhq.png",
  link: "/ServicesPage",
  colSpan: "md:col-span-1 lg:col-span-5"
}, {
  title: "Reinigung & Rückgabe",
  description: "Wir holen die Becher ab und reinigen sie professionell in unserer modernen Waschanlage.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/image_a9u1pg0b.png",
  link: "/ProcessPage",
  colSpan: "md:col-span-1 lg:col-span-7"
}];
export default function Offerings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222972" id="processandofferings" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16 text-center max-w-3xl mx-auto">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-4">
            Unser Prozess
          </h2>
          <p className="font-default text-muted-foreground text-lg">
            Von der ersten Anfrage bis zur professionellen Reinigung – wir begleiten Ihr Event nachhaltig.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {offeringsData.map((item, i) => <div key={i} data-index={i} className={`group relative overflow-hidden rounded-2xl min-h-[350px] md:min-h-[450px] flex flex-col justify-end shadow-md hover:shadow-xl transition-all duration-300 border border-border/50 backdrop-blur-sm ${item.colSpan}`}>
              <div className="absolute inset-0">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent transition-opacity duration-300 group-hover:opacity-95" />
              </div>

              <div className="relative z-10 p-6 md:p-8 flex flex-col items-start">
                <div className="mb-4 bg-secondary text-secondary-foreground px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest">
                  Schritt {i + 1}
                </div>
                <h3 className="font-default text-3xl md:text-4xl font-bold text-white mb-3 tracking-tight">
                  {item.title}
                </h3>
                <p className="font-default text-white/80 text-sm md:text-base mb-6 max-w-md line-clamp-2">
                  {item.description}
                </p>
                <Button asChild variant="default" className="rounded-full group/btn bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
                  <Link to={item.link}>
                    Mehr erfahren
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}